// extracted by mini-css-extract-plugin
export default {"Container":"HighlightBadge_Container__sx0ss"};